import { authenticatedBitswanBackendInstance } from "@/lib/api-client";

export type ChangePasswordInput = {
  current_password: string;
  new_password: string;
};

export async function changePassword(input: ChangePasswordInput) {
  const api = await authenticatedBitswanBackendInstance();
  const res = await api.post("/users/me/password", input);
  return res.data as { success: boolean };
}

export async function updateAvatar(avatar: string | null) {
  const api = await authenticatedBitswanBackendInstance();
  const res = await api.post("/users/me/avatar", { avatar });
  return res.data as { avatar: string | null };
}

export type ProfileInput = {
  first_name: string;
  last_name: string;
};

export async function updateProfile(input: ProfileInput) {
  const api = await authenticatedBitswanBackendInstance();
  const res = await api.post("/users/me/profile", input);
  return res.data as ProfileInput;
}

export type TwoFactorCredential = { id: string; label: string; created_at: number | null };
export type TwoFactorStatus = { enabled: boolean; credentials: TwoFactorCredential[] };

export async function fetchTwoFactorStatus() {
  const api = await authenticatedBitswanBackendInstance();
  const res = await api.get("/users/me/two-factor");
  return res.data as TwoFactorStatus;
}

export const SETUP_AUTHENTICATOR_ACTION = "CONFIGURE_TOTP";

export function removeCredentialAction(credentialId: string) {
  return `delete_credential:${credentialId}`;
}

export async function accountActionUrl(action: string) {
  const api = await authenticatedBitswanBackendInstance();
  const res = await api.get("/auth/keycloak-init", { params: { action } });
  return (res.data as { auth_url: string }).auth_url;
}
